import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as ModalDialogs from 'vue-modal-dialogs'
import CKEditor from 'ckeditor4-vue'

Vue.config.productionTip = false

Vue.use(ModalDialogs)
Vue.use(CKEditor)

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
